import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {NbDialogRef} from '@nebular/theme';
import { SupporterContactInfoModel } from '../../models/supporter-contact-info.model';

@Component({
  selector: 'morva-user-deactivated-error-dialog',
  templateUrl: './user-deactivated-error-dialog.component.html',
  styleUrls: ['./user-deactivated-error-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserDeactivatedErrorDialogComponent {

  supporterContactInfo: SupporterContactInfoModel;

  constructor(private dialogRef: NbDialogRef<any>) { }

  close() {
    this.dialogRef.close();
  }
}
